(() => {
  // ===== Debug utilities =====
  const Debug = {
    enabled: false,
    init(root) {
      const attr = root?.dataset?.debug;
      const ls = localStorage.getItem('fitment_debug');
      this.enabled = attr === '1' || ls === '1';
      if (this.enabled) {
        console.info('[YMM] Debug enabled');
      }
    },
    group(label, collapsed = true) {
      if (!this.enabled) return { end(){} };
      if (collapsed) console.groupCollapsed(label); else console.group(label);
      return { end(){ try { console.groupEnd(); } catch {} } };
    },
    //info(...args){ if (this.enabled) console.info('[YMM]', ...args); },
    //warn(...args){ if (this.enabled) console.warn('[YMM]', ...args); },
    //error(...args){ if (this.enabled) console.error('[YMM]', ...args); },
    time(label){ if (this.enabled) console.time(label); },
    timeEnd(label){ if (this.enabled) console.timeEnd(label); },
    mask(str){ if (!str) return str; return String(str).slice(0,4) + '***' + String(str).slice(-2); }
  };

  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const cache = new Map();

	// Put this ONCE at top-level (remove the inner duplicate)
	function selectNeedsSelection(selectEl) {
	  if (!selectEl || selectEl.disabled) return false; // must be active
	  const opt   = selectEl.options[selectEl.selectedIndex];
	  const val   = selectEl.value || '';
	  const label = opt ? (opt.textContent || '').trim() : '';
	  return /select/i.test(val) || /select/i.test(label);
	}

	function updateNeedsSelection(scope = document) {
	  // Be robust across realms: check by tagName, not instanceof
	  const isSelect = (el) => el && el.tagName && el.tagName.toUpperCase() === 'SELECT';

	  const list = isSelect(scope)
		? [scope]
		: (scope?.querySelectorAll ? Array.from(scope.querySelectorAll('select')) : []);

	  list.forEach(s => {
		const need = selectNeedsSelection(s);
		s.classList.toggle('needsSelection', need);
		// Optional debug trace:
		if (Debug.enabled) {
		  const opt = s.options[s.selectedIndex];
		  
		}
	  });
	}
  
  function lcKeys(obj) {
	  const o = {};
	  for (const [k, v] of Object.entries(obj || {})) {
		if (v !== undefined && v !== null && v !== '') o[k.toLowerCase()] = v;
	  }
	  return o;
	}

  async function apiGet(base, path, query, apiKey, dbgLabel='') {
    const cleanBase = base.replace(/\/$/, '');
  	const pathName  = String(path || '').replace(/^\//, ''); // "years"
  	const isPhp     = /\.php(?:$|\?)/i.test(cleanBase);

  	const qs = new URLSearchParams(lcKeys(query));
  	const url = isPhp
  	
	// hits: https://.../fits.php?endpoint=years&sku=...
	? `${cleanBase}${cleanBase.includes('?') ? '&' : '?'}endpoint=${encodeURIComponent(pathName)}&${qs}`
	// hits: https://.../api/years?sku=...
	: `${cleanBase}/${pathName}?${qs}`;
    const headers = { 'Accept': 'application/json' };
    if (apiKey) headers['Authorization'] = `Bearer ${apiKey}`;

    const grp = Debug.group(`API ${dbgLabel || path}: ${url}`);

    if (cache.has(url)) {
      const data = cache.get(url);
      grp.end();
      return data;
    }

    Debug.time(url);
    let res;
    try {
      res = await fetch(url, { headers, credentials: 'omit' });   // no cookies: fits.php has none
      const text = await res.text(); // read once for better error logs

      let data;
      try {
        data = text ? JSON.parse(text) : {};
      } catch (e) {
        //Debug.error('JSON parse error:', e);
        throw new Error(`Bad JSON from API (${res.status})`);
      }

      if (!res.ok) {
        const err = new Error(`API ${res.status}`);
        err.meta = { url, query, data };
        throw err;
      }

      cache.set(url, data);
      return data;
    } catch (e) {
      throw e;
    } finally {
      grp.end();
    }
  }

  function setOptions(selectEl, options, placeholder = 'Select…') {
    const grp = Debug.group(`setOptions(${selectEl?.id || 'unknown'})`);
    try {
      selectEl.innerHTML = '';
      const ph = document.createElement('option');
      ph.value = '';
      ph.textContent = placeholder;
      selectEl.appendChild(ph);

      const normalized = options.map(o => (typeof o === 'string' ? { value:o, label:o } : o));
      normalized.forEach(o => {
        const opt = document.createElement('option');
        opt.value = o.value ?? o;
        opt.textContent = o.label ?? o.value ?? '';
        selectEl.appendChild(opt);
      });
      selectEl.disabled = normalized.length === 0;
    } catch (e) {
    
    } finally {
      updateNeedsSelection(selectEl);
      grp.end();
    }
    
    
  }

  function setLoading(selectEl, loading = true) {
    selectEl.disabled = loading;
    selectEl.classList.toggle('is-loading', loading);
    updateNeedsSelection(selectEl);
  }

  function persistVehicle(vehicle) {
    try {
      localStorage.setItem('ymm_selection', JSON.stringify(vehicle));
      localStorage.setItem('pc_ymm_v1', JSON.stringify(vehicle));
      document.cookie = `ymm=${encodeURIComponent(JSON.stringify(vehicle))};path=/;max-age=${60*60*24*180}`;
      document.cookie = `pc_ymm=${encodeURIComponent(JSON.stringify(vehicle))};path=/;max-age=${60*60*24*30};SameSite=Lax`;
    } catch (e) {
    }
  }

  function readSkuFromPage() {
    // Prefer currently-selected variant SKU if theme updates it dynamically
    const variantSkuEl = document.querySelector('[data-product-sku]');
    if (variantSkuEl && variantSkuEl.textContent.trim()) return variantSkuEl.textContent.trim();

    // Fallback from data attribute placed by Liquid
    const root = $('#fitment-checker');
    return root?.dataset.initialSku || '';
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById('fitment-checker');
    if (!root) { console.warn('[YMM] #fitment-checker not found'); return; }
    Debug.init(root);

    //const API_BASE = root.dataset.apiBase || '/apps/fitment';
    const API_BASE = 'https://shopify.partcatalog.com/fits.php';
    const API_KEY  = root.dataset.apiKey || '';
    const STEPS    = JSON.parse(root.dataset.steps || '["year","make","model"]');

    /* Read vehicle saved by collection page (pc_ymm_v1) for cross-page restore */
    const savedVehicle = (() => {
      try {
        const raw = localStorage.getItem('pc_ymm_v1');
        if (raw) return JSON.parse(raw);
        const m = document.cookie.match(/(?:^|;)\s*pc_ymm=([^;]+)/);
        if (m) return JSON.parse(decodeURIComponent(m[1]));
      } catch {}
      return null;
    })();
    /*
     * restorePhase tracks where we are in the one-time initial restore sequence.
     * 'year'  → waiting to auto-select year after years load
     * 'make'  → year was auto-set; waiting to auto-select make after makes load
     * 'model' → make was auto-set; waiting to auto-select model after models load
     * 'done'  → restore complete (or not needed); never auto-select again
     */
    let restorePhase     = savedVehicle?.year ? 'year' : 'done';
    let pendingAutoVerify = false; // set true after full auto-restore; triggers auto-click
    let autoVerifyClick   = false; // true while a verify was triggered by session restore (skip scroll)
    let restoringExtras   = false; // true while auto-restoring saved dynamic qualifiers

    const selYear  = $('#fitment-year', root);
    const selMake  = $('#fitment-make', root);
    const selModel = $('#fitment-model', root);
    const dynWrap  = $('#fitment-dynamic', root);
    const btnVerify= $('#fitment-verify', root);
    const resultEl = $('#fitment-result', root);
    const btnChange= $('#fitment-change-vehicle', root);

    const state = {
      sku: readSkuFromPage(),
      selections: { year:'', make:'', model:'' },   // expand as needed
      dynamicFields: []                              // e.g. ["submodel","engine"]
    };
    window.__fitmentState = state; // expose for quick console inspection

    if (!state.sku) {
      resultEl.textContent = 'No SKU found on this product.';
      //Debug.error('SKU missing. Aborting init.');
      return;
    }

    // 1) Load Years for SKU
    (async () => {
      const grp = Debug.group('Step 1: Load Years');
      try {
        setLoading(selYear, true);
        const data = await apiGet(API_BASE, '/years', { sku: state.sku }, API_KEY, 'GET /years');
        const years = data.years ?? data.options ?? [];
        setOptions(selYear, years.map(y => (typeof y === 'number' || /^\d{4}$/.test(y)) ? String(y) : y), 'Select year');
        /* Auto-restore saved year (initial page load only) */
        if (restorePhase === 'year') {
          const target = String(savedVehicle.year);
          if (Array.from(selYear.options).some(o => o.value === target)) {
            restorePhase = 'make'; // advance - next step will auto-select make
            selYear.value = target;
            selYear.dispatchEvent(new Event('change'));
          } else {
            restorePhase = 'done'; // saved year not available for this product
          }
        }
      } catch (e) {
        resultEl.textContent = 'Could not load years. Please try again.';
        //Debug.error('Years load failed:', e);
      } finally {
        setLoading(selYear, false);
        grp.end();
      }
    })();

    // Helper: clear downstream selects + dynamic fields
    function resetFrom(step) {
      const grp = Debug.group(`resetFrom(${step})`);
      try {
        if (step === 'year') {
          setOptions(selMake, [], 'Select make'); selMake.disabled = true;
          setOptions(selModel, [], 'Select model'); selModel.disabled = true;
          dynWrap.innerHTML = '';
          state.dynamicFields = [];
        } else if (step === 'make') {
          setOptions(selModel, [], 'Select model'); selModel.disabled = true;
          dynWrap.innerHTML = '';
          state.dynamicFields = [];
        } else if (step === 'model') {
          dynWrap.innerHTML = '';
          state.dynamicFields = [];
        }
        btnVerify.disabled = true;
        resultEl.textContent = '';
        if (btnChange) btnChange.hidden = true;
      } finally {
        updateNeedsSelection(root);
        grp.end();
      }
    }
    
    // Helper: when a dynamic field changes, everything downstream of it is stale -
    // remove those rows from the DOM and forget their names/selections so the
    // next /extra-fields call re-asks from this point (fresh options, no duplicates).
    function resetDynamicAfter(fieldName) {
      const idx = state.dynamicFields.indexOf(fieldName);
      if (idx === -1) return;
      const removed = state.dynamicFields.splice(idx + 1);
      removed.forEach(n => { delete state.selections[n]; });
      const input = document.getElementById(`fitment-${fieldName}`);
      const row = input ? input.closest('.fitment-row') : null;
      if (row) {
        while (row.nextSibling) row.nextSibling.remove();
      }
    }

    async function loadNextExtraField() {
		  // Build query from current selections
		  const query = { sku: state.sku, ...state.selections };

		  // Ask API what the NEXT field is (0 or 1 field expected)
		  const data = await apiGet(API_BASE, '/extra-fields', query, API_KEY);
		  const fields = data.fields ?? [];

		  // If no more fields, enable Verify (if core Y/M/M are chosen)
		  if (!fields.length) {
			btnVerify.disabled = !readyToVerify();
			// End of a session-restore cascade: every saved qualifier was
			// re-selected, so finish the way the user left it - auto-verify.
			if (restoringExtras) {
			  restoringExtras = false;
			  if (pendingAutoVerify && !btnVerify.disabled) {
				pendingAutoVerify = false;
				setTimeout(() => { autoVerifyClick = true; btnVerify.click(); }, 100);
			  }
			}
			return false; // no field rendered
		  }

		  // Render the next field
		  const f = fields[0];
		  const id = `fitment-${f.name}`;

		  // Track order (so readyToVerify knows what's expected)
		  if (!state.dynamicFields.includes(f.name)) {
			state.dynamicFields.push(f.name);
		  }

		  const row = document.createElement('div');
		  row.className = 'fitment-row';

		  const label = document.createElement('label');
		  label.setAttribute('for', id);
		  label.textContent = f.label || (f.name.charAt(0).toUpperCase() + f.name.slice(1));

		  let input;
		  if (f.type === 'select') {
			input = document.createElement('select');
			input.id = id;
			setOptions(input, f.options || [], `Select ${f.label || f.name}`);
		  } else {
			input = document.createElement('input');
			input.id = id;
			input.type = f.type || 'text';
			input.placeholder = f.placeholder || '';
		  }

		  // While awaiting this field, don't allow Verify
		  btnVerify.disabled = true;

		  input.addEventListener('change', async () => {
			state.selections[f.name] = input.value || '';

			// Changing this field invalidates every field after it - tear them down
			// so they are re-fetched fresh (instead of appending duplicates).
			resetDynamicAfter(f.name);

			resultEl.textContent = '';
			btnVerify.disabled = true;
			updateNeedsSelection(root);

			// Back on the placeholder ("Select…"): stop here, wait for a real choice
			if (!input.value) return;

			// After choosing this field, immediately check if there is ANOTHER field
			try {
			  await loadNextExtraField();  // recursion: keeps going until none remain
			} catch {
			  // If the call fails, keep Verify disabled until user retries or changes selection
			  btnVerify.disabled = true;
			  restoringExtras = false;
			  pendingAutoVerify = false;
			}
		  });

		  row.appendChild(label);
		  row.appendChild(input);
		  dynWrap.appendChild(row);
		  updateNeedsSelection(root);

		  // Session-restore: if this qualifier was saved with the vehicle,
		  // auto-select it and let the change handler continue the cascade.
		  if (restoringExtras) {
			const saved = savedVehicle?.[f.name] != null ? String(savedVehicle[f.name]) : '';
			const restorable = saved !== '' && (
			  f.type !== 'select' ||
			  Array.from(input.options || []).some(o => o.value === saved)
			);
			if (restorable) {
			  input.value = saved;
			  input.dispatchEvent(new Event('change'));
			} else {
			  // Saved value missing or no longer offered - hand over to the user
			  restoringExtras = false;
			  pendingAutoVerify = false;
			}
		  }

		  return true; // rendered a field
		}


    // 2) Year → Makes
    selYear?.addEventListener('change', async () => {
      state.selections.year = selYear.value || '';
      resetFrom('year');
      updateNeedsSelection(root);
      if (!state.selections.year) return;

      const grp = Debug.group('Step 2: Load Makes');
      try {
        setLoading(selMake, true);
        const data = await apiGet(API_BASE, '/makes', { sku: state.sku, year: state.selections.year }, API_KEY, 'GET /makes');
        const makes = data.makes ?? data.options ?? [];
        setOptions(selMake, makes, 'Select make');
        /* Auto-restore saved make (initial page load only) */
        if (restorePhase === 'make' && savedVehicle?.make &&
            Array.from(selMake.options).some(o => o.value === savedVehicle.make)) {
          restorePhase = 'model'; // advance - next step will auto-select model
          selMake.value = savedVehicle.make;
          selMake.dispatchEvent(new Event('change'));
        } else {
          restorePhase = 'done'; // user manually changed year; stop restoring
        }
      } catch (e) {
        resultEl.textContent = 'Could not load makes.';
        //Debug.error('Makes load failed:', e);
      } finally {
        setLoading(selMake, false);
        updateNeedsSelection(root);
        grp.end();
      }
    });

    // 3) Make → Models
    selMake?.addEventListener('change', async () => {
      state.selections.make = selMake.value || '';
      resetFrom('make');
      updateNeedsSelection(root);
      if (!state.selections.make) return;

      const grp = Debug.group('Step 3: Load Models');
      try {
        setLoading(selModel, true);
        const data = await apiGet(API_BASE, '/models', {
          sku: state.sku,
          year: state.selections.year,
          make: state.selections.make
        }, API_KEY, 'GET /models');
        const models = data.models ?? data.options ?? [];
        setOptions(selModel, models, 'Select model');
        /* Auto-restore saved model (initial page load only) */
        if (restorePhase === 'model' && savedVehicle?.model &&
            Array.from(selModel.options).some(o => o.value === savedVehicle.model)) {
          restorePhase = 'done';    // restore complete
          pendingAutoVerify = true; // auto-click verify if no extra fields needed
          selModel.value = savedVehicle.model;
          selModel.dispatchEvent(new Event('change'));
        } else {
          restorePhase = 'done'; // user manually changed make; stop restoring
        }
      } catch (e) {
        resultEl.textContent = 'Could not load models.';
        //Debug.error('Models load failed:', e);
      } finally {
        setLoading(selModel, false);
        updateNeedsSelection(root);
        grp.end();
      }
    });

    // 4) Model → extra fields (0..N)
    selModel.addEventListener('change', async () => {
	  state.selections.model = selModel.value || '';
	  resetFrom('model');
	  updateNeedsSelection(root);
	  if (!state.selections.model) return;

	  try {
		// If this model change is part of the session-restore cascade, keep
		// restoring the saved dynamic qualifiers too (auto-select each one).
		restoringExtras = pendingAutoVerify;

		// Start the cascade: this will render the first extra field (if any),
		// and then keep asking for more each time the user selects one.
		const rendered = await loadNextExtraField();

		// If there were no extra fields at all, allow verify immediately
		if (!rendered) {
		  restoringExtras = false;
		  btnVerify.disabled = !readyToVerify();
		  // Auto-click after a full session-restore cascade (no extra questions needed)
		  if (pendingAutoVerify && !btnVerify.disabled) {
		    pendingAutoVerify = false;
		    setTimeout(() => { autoVerifyClick = true; btnVerify.click(); }, 100);
		  }
		} else if (!restoringExtras) {
		  // Extra fields appeared and we're not auto-restoring them -
		  // the user must answer, so cancel any pending auto-verify
		  pendingAutoVerify = false;
		}
	  } catch (e) {
		// If the extra-fields request fails, don't allow verify yet
		btnVerify.disabled = true;
	  }
	});


function readyToVerify() {
  if (!state.selections.year || !state.selections.make || !state.selections.model) return false;
  return state.dynamicFields.every(n => !!state.selections[n]);
}


    // 5) Verify
	btnVerify?.addEventListener('click', async () => {
	  const grp = Debug.group('Step 5: Verify');
	  const wasAuto = autoVerifyClick;
	  autoVerifyClick = false;
	  btnVerify.disabled = true;

	  // Reset both result containers
	  const resultTrueEl  = document.getElementById('fitment-result-true');
	  const resultFalseEl = document.getElementById('fitment-result-false');
	  const containerEl   = document.getElementById('fitment-container');

	  if (resultTrueEl)  resultTrueEl.textContent  = '';
	  if (resultFalseEl) resultFalseEl.textContent = '';

	  // Temporary loading text
	  if (resultTrueEl)  resultTrueEl.style.display  = 'none';
	  if (resultFalseEl) resultFalseEl.style.display = 'none';

	  // Audit TH-3: the backend message used to be assigned to innerHTML. It is
	  // now reduced to text nodes (+ <strong>/<br> structure only) by the shared
	  // renderer in pc-fitment-text.js, with a plain-text fallback.
	  const renderFitmentMessage = (el, html) => {
		if (window.PCFitmentText && window.PCFitmentText.renderMessage) { window.PCFitmentText.renderMessage(el, html); return; }
		el.textContent = String(html || '').replace(/<br\s*\/?>/gi, ' ').replace(/<[^>]*>/g, '');
	  };
	  try {
		const payload = { sku: state.sku, ...state.selections };

		const data = await apiGet(API_BASE, '/verify', payload, API_KEY, 'GET /verify');
		const fits = !!data.fits;
		const msg  = data.message || (fits
		  ? 'This item fits your vehicle.'
		  : 'This item does not fit your vehicle.');

		// Choose correct container
		const resultEl = fits ? resultTrueEl : resultFalseEl;

		// Show message in correct result div
		if (resultEl) {
		  renderFitmentMessage(resultEl, msg);   // text nodes, never innerHTML
		  resultEl.style.display = 'block';
		  resultEl.classList.toggle('fitment-pass', fits);
		  resultEl.classList.toggle('fitment-fail', !fits);
		}

		// Move focus to the result before hiding the container it may be inside
		if (containerEl && resultEl && containerEl.contains(document.activeElement)) {
		  resultEl.setAttribute('tabindex', '-1');
		  resultEl.focus();
		}

		// Hide the main fitment form container; offer "Change Vehicle" instead
		if (containerEl) containerEl.style.display = 'none';
		if (btnChange) btnChange.hidden = false;

		persistVehicle(payload);
		// Report the check to Relay. The guarantee pop-up/modal set
		// window.__pcFitmentSurface while they host the checker; bare page = inline.
		try {
		  if (window.Relay && window.Relay.track) {
			// flat props - Relay.track's second argument IS the props object
			window.Relay.track('fitment_checked', {
			  sku: state.sku,
			  result: fits ? 'fits' : 'does_not_fit',
			  surface: window.__pcFitmentSurface || 'pdp_inline',
			  ...(wasAuto ? { auto: true } : {})
			});
		  }
		} catch (e) {}
		root.dispatchEvent(new CustomEvent('fitment:verified', {
		  detail: { fits, payload, raw: data }
		}));
		if (!fits) {
		  document.dispatchEvent(new CustomEvent('fitment:no-fit', {
		    detail: {
		      vehicle: state.selections,
		      collectionUrl: root.dataset.collectionUrl || '/collections/all'
		    }
		  }));
		}
	  } catch (e) {
		if (resultFalseEl) {
		  resultFalseEl.textContent = 'Could not verify fitment. Please try again.';
		  resultFalseEl.style.display = 'block';
		}
		//Debug.error('Verify failed:', e);
	  } finally {
		btnVerify.disabled = !readyToVerify();
		grp.end();
	  }
	});

    // 6) Change Vehicle: reopen the form from a result screen, selections intact
    btnChange?.addEventListener('click', () => {
      const containerEl   = document.getElementById('fitment-container');
      const resultTrueEl  = document.getElementById('fitment-result-true');
      const resultFalseEl = document.getElementById('fitment-result-false');

      if (resultTrueEl)  { resultTrueEl.textContent = '';  resultTrueEl.style.display = 'none'; }
      if (resultFalseEl) { resultFalseEl.textContent = ''; resultFalseEl.style.display = 'none'; }
      resultEl.textContent = '';

      if (containerEl) containerEl.style.display = '';
      btnChange.hidden = true;
      btnVerify.disabled = !readyToVerify();
      updateNeedsSelection(root);
      selYear?.focus();
    });

  });
  
})();
